import glamorous from 'glamorous';

export const Header = glamorous.header({
  position: 'absolute',
  width: '100%',
  height: '60px',
  zIndex: '10',
  backgroundColor: 'white',
  '@media(max-width: 480px)': {
    height: '50px',
  },
});

export const LogoContainer = glamorous.div({
  maxWidth: '1024px',
  margin: 'auto',
  position: 'relative',
});

export const PartnerLogo = glamorous.a(
  {
    position: 'absolute',
    top: '10px',
    left: '10px',
    width: '50%',
    height: '43px',
    textIndent: '-9999px',

    '@media(max-width: 480px)': {
      top: '5px',
      height: '45px',
    },
  },
  ({ logo }) => ({
    background: `transparent url(${logo}) left center no-repeat`,
    backgroundSize: 'contain',
  })
);

export const PayPalLogo = glamorous.a(({ cdnHost }) => ({
  background: `transparent url(https://${cdnHost}/webstatic/i/logo/rebrand/ppcom.svg) center center no-repeat`,
  backgroundSize: '124px 33px',
  position: 'absolute',
  top: '10px',
  right: '0px',
  width: '136px',
  height: '43px',
  textIndent: '9999px',

  '@media(max-width: 480px)': {
    background: `transparent url(https://${cdnHost}/webstatic/i/logo/rebrand/ppcom.svg) center center no-repeat`,
    backgroundSize: '124px 33px',
    position: 'absolute',
    top: '5px',
    width: '35px',
    height: '45px',
    overflow: 'hidden',
    textIndent: '9999px',
    backgroundPosition: '8px',
  },
}));
